import { getFormattedDateRange, Options } from "@clockwise/web-commons/src/util/date.util";
import { Interval } from "luxon";
import { Maybe } from "purify-ts";

export const getFormattedDateFromInterval = (time: string | null, options?: Options) =>
  Maybe.fromNullable(time)
    .map((time) =>
      Interval.fromISO(time).isValid
        ? {
            start: Interval.fromISO(time).start.toISO(),
            end: Interval.fromISO(time).end.toISO(),
          }
        : null,
    )
    .chain((time) => Maybe.fromNullable(time))
    .map(({ start, end }) => getFormattedDateRange({ start, end, options }))
    .extract();
